import _ from 'lodash'

class AuthController {
  constructor(authService, $location, $log, flash, config) {
    this.$log = $log
    this.flash = flash
    this.submitting = false

    this.authService = authService
    this.credentials = {
      'username': '',
      'password': '',
      'appName': config.appName
    }
    this.$location = $location
  }

  login() {
    this.submitting = true
    this.authService.login(
      this.credentials,
      this._onLogin.bind(this),
      this._onLoginFailed.bind(this))
  }

  _onLogin() {
    this.submitting = false
    if ( this.$location.search().redirectTo ) {
      this.$location.url(this.$location.search().redirectTo)
    } else {
      this.$location.url('/search')
    }
  }

  _onLoginFailed(response) {
    this.submitting = false
    this.flash.setMessage("Your Login failed.  Check your credentials and try again.")
    this.$location.url('/login')
  }

  logout() {
    this.authService.logout()
    this.$location.url('')
  }

  path() {
    return this.$location.path()
  }

  get flashMessage() {
    return this.flash.currentMessage
  }

}

AuthController.$inject = ['AuthService', '$location', '$log', 'flash', 'config']

export default AuthController
